import { IState } from '../../store';
import { IInfrastructureFromBuilder } from '../../types/transportAccessibility';

export const selectInfrastructureFromBuilder = (state: IState): IInfrastructureFromBuilder | null => {
  const { transportAccessibility } = state.offerData;

  if (!transportAccessibility) {
    return null;
  }

  return transportAccessibility.infrastructure || null;
};
